import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useData } from "@pure-ptr/react";
import React, { useContext,useState } from 'react';
import { getServiceLineUnderpaymentsSummary } from "../../store/api/summaryDashboard";
import { asDollarsWithZero } from '../../util/format';
import { DashboardFiltersContext, useStyles } from './Dashboard';
import { useDispatch } from 'react-redux';
import { setMulti } from '../../store/actions/pages';
import { nonPaginatedSorting } from '../../util';
import WidgetsSortingComponent from './WidgetsSortingComponent';

export const ServiceLineUnderpayments = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [sortConfig, setSortConfig] = useState({ key: 'contractName', direction: 'asc' }); 
    
    const { dateRange, history } = useContext(DashboardFiltersContext);

    const { data, isPending } = useData( async () => {
        const result = await getServiceLineUnderpaymentsSummary(dateRange.startdate, dateRange.enddate);
        return result;
    }, [ dateRange ]);

    const sortableColumns = [
        { key: 'contractName', label: 'Contract' },
        { key: 'facilityName', label: 'Facility' },
        { key: 'totalLineItems', label: 'Count' },
        { key: 'totalAmount', label: 'Total Amount' },
    ];

    const handleServiceLineAmountClick = (contractName, facilityId) => {
        let filters = [
            {
                actualFilter: true, 
                equator: "greater_than", 
                field: "variance", 
                value: 0
            },
            {
                actualFilter: true, 
                equator: "equals", 
                field: "contractName", 
                value: contractName
            }
        ];

        if(facilityId != null) {
            filters.push({
                actualFilter: true, 
                equator: "equals", 
                field: "facilityId", 
                value: facilityId
            });
        }

        dispatch( setMulti('charge-analysis-landing', {
            filter: filters,
            selectedFilter: null,
            customFilter: [
                {
                    customFilter: true, 
                    equator: "greater_than_or_equals_to", 
                    field: "remitdate", 
                    value: dateRange.startdate,
                    relativeFilter:dateRange.relativeFilter
                },
                {
                    customFilter: true, 
                    equator: "less_than_or_equals_to", 
                    field: "remitdate", 
                    value: dateRange.enddate,
                    relativeFilter:dateRange.relativeFilter
                },
                {
                    customFilter: true, 
                    equator: "equals", 
                    field: "isPaid", 
                    value: true
                },
                {
                    customFilter: true, 
                    equator: "equals", 
                    field: "isDenial", 
                    value: false
                },
                {
                    customFilter: true, 
                    equator: "equals", 
                    field: "acknowledged", 
                    value: false
                }
            ],
            list: [],
            significance: false,
            searchTerm:"",
        }));

        history.push("/cms/charge-analysis/fromSummary");
    }

    const sortedData = React.useMemo(
        () =>
            nonPaginatedSorting(
                [sortConfig],
                [...(data || [])]
            )?.tableData,
        [data, sortConfig]
    );


    return isPending ? (
        <CircularProgress />
    ) : (
        <Table stickyHeader>
            <TableHead>
                <TableRow key='serviceLineUnderpaymentsHeader'>
                    <WidgetsSortingComponent sortableColumns={sortableColumns} sortConfig={sortConfig} setSortConfig={setSortConfig}/>
                </TableRow>
            </TableHead>
            <TableBody>
                {sortedData?.map((claim) => (
                    <TableRow key={claim.contractName}>
                        <TableCell>{claim.contractName}</TableCell>
                        <TableCell>{claim.facilityName ?? 'N/A'}</TableCell>
                        {/* <TableCell>{asDollarsWithZero(claim.perServiceDollars)}</TableCell> */}
                        <TableCell>{claim.totalLineItems}</TableCell>
                        <TableCell>
                            <Typography onClick={()=> handleServiceLineAmountClick(claim.contractName, claim.facilityId ?? "none")}    
                            variant="body2" className={classes.link}>
                                {asDollarsWithZero(claim.totalAmount)}
                            </Typography>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}